import { Theme } from './theme'

export default function getColorFromTheme(color: Theme, def?: string) {
  const root = document.documentElement
  if (root) {
    return getComputedStyle(root).getPropertyValue(`--${color}`) || def
  }
}
